/* eslint jsx-a11y/href-no-hash: "off" */

import React from "react";
import { connect } from "react-redux";
// import MenuHeaderInviteLink from "./MenuHeaderInviteLink";
import { goToHomeScreen } from "../b5-home/get-home-menu-options.js";

class MenuHeader extends React.Component {
  handleGoToHomeScreen(e) {
    e.preventDefault();
    goToHomeScreen();
  }

  getContext() {
    if (
      this.props.gameArea === "arena" &&
      this.props.currentRoomType === "fullteam"
    ) {
      return "fullteam";
    }

    if (
      this.props.gameArea === "arena" &&
      this.props.currentRoomType === "open"
    ) {
      return "rally";
    }

    if (this.props.gameArea === "b5-records-screen") {
      return "records";
    }

    return "home";
  }

  getTitleText(context) {
    if (context === "fullteam") {
      return "" //"Versus Battle";
    }

    if (context === "rally") {
      return "" //"Rally Battle";
    }

    if (context === "records") {
      return "Battle Record";
    }

    return "Assemble Your Crew";
  }

  renderLeftLink(context) {
    if (context === "fullteam" || context === "rally") {
      return (
        <a className="menu-header__link" href="/">
          Cancel
        </a>
      );
    }

    if (context === "records") {
      return (
        <a
          className="menu-header__link"
          href="#"
          onClick={this.handleGoToHomeScreen.bind(this)}
        >
          Back
        </a>
      );
    }

    return null;
  }

  renderRightLink(context) {
    // if (context === "fullteam" || context === "rally") {
    //   return <MenuHeaderInviteLink />;
    // }
    return null;
  }

  render() {
    const context = this.getContext();

    return (
      <div className="menu-header">
        <div>
          {this.renderLeftLink(context)}
        </div>
        <div className="menu-header--center-section">
          {this.getTitleText(context)}
        </div>
        <div>
          {this.renderRightLink(context)}
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    gameArea: state.global.gameArea,
    currentRoomType: state.matchmaking.currentRoomType
  };
})(MenuHeader);



// WEBPACK FOOTER //
// ./src/b5-home/MenuHeader.js